<template>
  <div class="wrap">
    <div class="relative date-picker-wrap point">
      <img src="../../assets/image/icon/space/calendar_month.svg"
           alt="">
      <div id="datepicker">{{ startDateShow }}</div>
      <div class="absolute left-0 top-0 right-0 bottom-0" @click="picker.show()"></div>
    </div>

    <div class="arrow-wrap">
      <img class="arrow"
           src="../../assets/image/icon/space/arrow_down.svg"
           alt="">
    </div>

    <div class="date-picker-wrap point mb-[20px]"
         style="position: relative;">
      <img src="../../assets/image/icon/space/calendar_month.svg"
           alt="">
      <div id="datepickerEnd">{{ endDateShow }}</div>
      <!-- <div v-else>{{ $t('space.end_day') }}</div> -->
      <div class="absolute left-0 top-0 right-0 bottom-0" @click="pickerEnd.show()"></div>
    </div>

  </div>
</template>
<script setup>
import {computed, nextTick, onMounted, ref} from "vue";
import {DateTime, easepick, LockPlugin} from "@easepick/bundle";
import {DateFormat} from '@/utils/dateFormat.js'
import {useI18n} from '#imports';
import {isDateLocked} from "~/utils/newPriceTool.ts";
import {canRentMaxDay} from "@/config/common.js";

const {t} = useI18n();

const picker = ref(null)
const pickerEnd = ref(null)
const startDate = ref('')
const startDateShow = ref(t('space.day_placeholder'))
const endDate = ref('')
const endDateShow = ref('')


const props = defineProps({
  advanceBookingDays: {
    type: Number,
    default: 0
  },
  spaceUsageStatus: {
    type: Array,
    default: []
  },
  spaceRent: {
    type: Object,
    default: undefined
  },
})
const lockDate = computed(() => {
  return props.spaceUsageStatus.map(d => new DateTime(d.date, 'YYYY/MM/DD'))
})

const emit = defineEmits(['onTimeSelected'])

function onTimeSelected() {
  // 有選日期，而且日期合理 (start >= end)
  const isOK = startDate.value !== '' && endDate.value !== '' && new Date(endDate.value) >= new Date(startDate.value)
  const rent_type = 1
  const begin_time = `${startDate.value} 00:00:00`
  const end_time = `${endDate.value} 23:59:59`
  emit('onTimeSelected', isOK, rent_type, begin_time, end_time)
}

watch(() => props.spaceRent, () => {
  updatePicker()
})

function updatePicker() {
  picker.value?.destroy()
  pickerEnd.value?.destroy()
  initDatePicker()
}

onMounted(() => {
  initDatePicker()
})

function initDatePicker() {
  const todayDate = new Date();

  const maxDate = new Date().setDate(todayDate.getDate() + canRentMaxDay);

  todayDate.setDate(todayDate.getDate() + props.advanceBookingDays)

  let defaultDay = new Date()
  defaultDay.setDate(defaultDay.getDate() + props.advanceBookingDays)

  /////////////////////////////////////////////////////////////////////
  /// 避開已預定日期邏輯 start
  /////////////////////////////////////////////////////////////////////
  /// 原先避開已預定日期邏輯
  // for (let i = 0; i < props.spaceUsageStatus.length; i++) {
  //   if (props.spaceUsageStatus[i].date === DateFormat.format.date(defaultDay, 'yyyy/MM/dd')) {
  //     defaultDay.setDate(defaultDay.getDate() + 1)
  //   }
  // }
  /// 新 避開已預定日期邏輯
  const isLocked = (date) => {
    const formattedDate = DateFormat.format.date(date, 'yyyy/MM/dd');
    return (
        date.inArray(lockDate.value, '[]') ||
        isDateLocked(props.spaceRent, formattedDate) ||
        props.spaceUsageStatus.some((status) => status.date === formattedDate)
    )
  }
  let count = 0
  while (isLocked(new DateTime(defaultDay, 'YYYY/MM/DD')) && count < canRentMaxDay) {
    defaultDay.setDate(defaultDay.getDate() + 1)
    count++
  }
  /////////////////////////////////////////////////////////////////////
  /// 避開已預定日期邏輯 end
  /////////////////////////////////////////////////////////////////////

  let option = {
    element: document.getElementById('datepicker'),
    plugins: [LockPlugin],
    css: [
      'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'
    ],
    zIndex: 99,
    lang: 'zh-TW',
    date: defaultDay,
    LockPlugin: {
      minDate: todayDate,
      maxDate: maxDate,
      inseparable: true,
      filter(date, picked) {
        return isDateLockedHelper(date)
      },
    },
    setup(picker) {
      picker.on('select', selectStartDate)
    },
  }

  picker.value = new easepick.create(option);


  let optionEnd = {
    element: document.getElementById('datepickerEnd'),
    plugins: [LockPlugin],
    css: [
      'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'
    ],
    zIndex: 99,
    lang: 'zh-TW',
    date: defaultDay,
    LockPlugin: {
      minDate: todayDate,
      maxDate: maxDate,
      inseparable: true,
      filter(date, picked) {
        return isDateLockedHelper(date)
      },
    },
    setup(picker) {
      picker.on('select', selectEndDate)
    },
  }

  pickerEnd.value = new easepick.create(optionEnd);

  selectStartDate({detail: {date: defaultDay}})
}

// 檢查日期是否被鎖定的輔助函數
function isDateLockedHelper(date) {
  const formattedDate = DateFormat.format.date(date, 'yyyy/MM/dd');
  const dateTime = new DateTime(date, 'YYYY/MM/DD');
  return dateTime.inArray(lockDate.value, '[]') || isDateLocked(props.spaceRent, formattedDate);
}

// 尋找開始日期之後第一個被鎖定的日期
function findNextLockedDate(startDate) {
  const checkDate = new Date(startDate);
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + canRentMaxDay);
  
  for (let i = 1; i <= canRentMaxDay; i++) {
    checkDate.setDate(checkDate.getDate() + 1);
    
    if (checkDate > maxDate) {
      return null; // 未找到鎖定日期或超出最大範圍
    }
    
    if (isDateLockedHelper(checkDate)) {
      // 返回找到的鎖定日期前一天
      const previousDate = new Date(checkDate);
      previousDate.setDate(previousDate.getDate() - 1);
      return previousDate;
    }
  }
  
  return null; // 未找到鎖定日期
}

// 檢查兩個日期之間是否有被鎖定的日期
function hasLockedDateBetween(startDate, endDate) {
  if (!endDate || startDate > endDate) {
    return false;
  }
  
  const checkDate = new Date(startDate);
  const daysToCheck = Math.ceil((endDate - startDate) / (24 * 60 * 60 * 1000));
  
  for (let i = 1; i <= daysToCheck; i++) {
    checkDate.setDate(checkDate.getDate() + 1);
    
    if (checkDate > endDate) {
      break;
    }
    
    if (isDateLockedHelper(checkDate)) {
      return true;
    }
  }
  
  return false;
}

function selectStartDate(event) {
  startDateShow.value = 'yyyy/MM/dd'

  nextTick(() => {
    startDate.value = DateFormat.format.date(event.detail.date, 'yyyy/MM/dd')
    startDateShow.value = DateFormat.format.date(event.detail.date, 'yyyy年MM月dd日 (E)')

    /// 下面處理 endDate picker 的邏輯順序整理
    /// 1. 更新 endDate minDate 為 startDate
    /// 2. 更新 endDate maxDate (從 startDate 往後找第一個 lockDate 或是到 canRentMaxDay)
    /// 3. 重新載入 min/max 設定
    /// 4. 判斷結束日期是否合法？避免選中範圍中間有不可選日期 
    /// (結束日期為空、開始日期晚於結束日期、start-end 中間有鎖定日期 -> 重設為開始日期) 
    
    // 更新結束日期選擇器的可選範圍
    const lockPlugin = pickerEnd.value.PluginManager.getInstance('LockPlugin');
    const startDateTime = new DateTime(event.detail.date, 'YYYY/MM/DD');
    
    // 設定最小日期為開始日期
    lockPlugin.options.minDate = startDateTime;
    
    // 尋找下一個被鎖定的日期作為最大日期
    const nextLockedDate = findNextLockedDate(event.detail.date);
    
    // 設定最大可選日期
    if (nextLockedDate) {
      lockPlugin.options.maxDate = new DateTime(nextLockedDate, 'YYYY/MM/DD');
    } else {
      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + canRentMaxDay);
      lockPlugin.options.maxDate = new DateTime(maxDate, 'YYYY/MM/DD');
    }
    
    // 重新載入 min/max 設定
    pickerEnd.value.renderAll();
    
    // 處理結束日期
    const newStartDate = new Date(event.detail.date);
    const currentEndDate = endDate.value ? new Date(endDate.value) : null;
    
    // 如果需要重設結束日期（結束日期為空、開始日期晚於結束日期、start-end 中間有鎖定日期）
    if (!currentEndDate || newStartDate > currentEndDate || hasLockedDateBetween(newStartDate, currentEndDate)) {
      // 重設為開始日期
      pickerEnd.value.setDate(event.detail.date);
      selectEndDate({detail: {date: event.detail.date}});
      
      // 設置日期選擇器視圖到選擇的月份
      if (pickerEnd.value.ui && pickerEnd.value.ui.container) {
        pickerEnd.value.gotoDate(new Date(event.detail.date));
      }
    }

    onTimeSelected();
  })
}

function selectEndDate(event) {
  endDateShow.value = 'yyyy/MM/dd'

  nextTick(() => {
    endDate.value = DateFormat.format.date(event.detail.date, 'yyyy/MM/dd')
    endDateShow.value = DateFormat.format.date(event.detail.date, 'yyyy年MM月dd日 (E)')

    onTimeSelected()
  })
}
</script>
<style scoped
       lang="scss">
.wrap {
  @apply pt-[16px] relative;
  // 這邊加上 relative 給 datepicker 可以滑動

  .date-picker-wrap {
    @apply flex items-center justify-center w-full h-[50px] text-[18px] text-osn-dark-grey-00 font-bold rounded-[50px];
    border: 1px solid var(--osn-grey-03, #E1E0E0);

    img {
      @apply w-[20px] mr-[6px];
    }
  }

  .arrow-wrap {
    @apply w-full flex items-center justify-center;
    .arrow {
      @apply w-[10px] my-[14px];
    }
  }

}
</style>
